import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { useForm, FormProvider } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { SetStateAction, Dispatch } from "react";
interface IFilterCliente {
    updateClientes: (name: string) => void;
    setName: Dispatch<SetStateAction<string>>;
    name: string;
}

export default function FilterCliente(props: IFilterCliente) {
    const FormMethods = useForm();

    function handleFilterFormSubmit(formData: any) {
        props.updateClientes(formData.DS_NOME);
    }

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={handleFilterFormSubmit}
                className="form-group row"
            >
                <div className="col-12 mt-3">
                    <label>Nome</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        name="DS_NOME"
                        defaultValue={props.name}
                    />
                </div>
                <UnForm.SubmitButton
                    color="success"
                    icon={faFilter}
                    type="submit"
                    className="btn btn-block btn-outline-dark mt-4"
                >
                    Filtrar
                </UnForm.SubmitButton>
            </UnForm>
        </FormProvider>
    );
}
